import React, { FunctionComponent } from 'react';
import { Box, Typography } from '@material-ui/core';
import customiseOptionsTotalStyles from './customiseOptionsTotalStyles';
import Translation from '../../../../../../../common/components/translation/Translation';

export interface IOptionsTotalProps {
  optionsTotal: number;
  code?: string;
}

const CustomiseOptionsTotal: FunctionComponent<IOptionsTotalProps> = ({ optionsTotal, code }) => {
  const styles = customiseOptionsTotalStyles();

  return (
    <Box display="flex" className={styles.optionsContainer} data-test={`options:category:count:${code}`}>
      <Typography className={styles.optionsTotalValue}>{optionsTotal}</Typography>
      <Typography className={styles.optionsTotalLabel}>
        <Translation
          id={`trans__configurator__customise_page_accessories_section__${optionsTotal === 1 ? 'item' : 'items'}`}
          values={{ total: optionsTotal }}
        />
      </Typography>
    </Box>
  );
};

export default CustomiseOptionsTotal;
